import ComponentMap from "./component-map"
import Slugify from "slugify"

const PageSection = ({ content, locale, index }) => {
  if (content.section_content === null) {
    return <></>
  }

  const sections = content.section_content
  const sluggedName = Slugify(content.name, { lower: true })
  const sectionClass = content.className ? content.className : ""

  return (
    <section
      key={`${sluggedName}-${index}`}
      id={sluggedName}
      className={`fdc-${content.contentful_id} page-section__${sluggedName} section section--page-section block__${sections.length}-column ${sectionClass}`}
    >
      <div className="row">
        {sections.map((content, index) => {
          const Cname = content.template ? ComponentMap[content.template] : ComponentMap[content.__typename]
          if (Cname === undefined) {
            return (
              <h1 key={index} style={{ color: "red" }}>
                Template missing for {content.template}
              </h1>
            )
          }
          const contentName = content.title ? Slugify(content.title.toLowerCase()) : ""
          const className = content.className || ""

          return (
            <div key={`${contentName}-${index}`} className={`column column__${contentName} ${className}`}>
              <Cname content={content} locale={locale} index={index} />
            </div>
          )
        })}
      </div>
    </section>
  )
}

export default PageSection
